import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Input } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import JobInfoBanner from "./components/JobInfoBanner";
import AvensysLogo2Img from "@workspace/main/src/assets/images/Avensys Logo 2.png";
import {
  generateInitialValues,
  generateSchema,
} from "./ratingSystemFormikConfig";
import { useFormik } from "formik";
import { fetchJobPortalJob } from "../../../store/job/action";
import Rate from "rc-rate";
import "rc-rate/assets/index.css"; // Ensure you import the required CSS
import "./RatingSystem.scss";

const questionHeaders = ["Question", "Your Answer", "Experience", "Rating"];

const RatingSystem = ({ onCancel }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [initialValues, setInitialValues] = useState();
  const [schema, setSchema] = useState();
  const [interviewQuestions, setInterviewQuestions] = useState([]);

  // Get global state variables from redux store
  const jobRaw = useSelector(
    (state) => state.JobPortalJobReducer.job.submissionData
  );

  // Fetch job details from server
  useEffect(() => {
    dispatch(fetchJobPortalJob(jobId));
  }, [jobId]);

  useEffect(() => {
    if (jobRaw) {
      const job = JSON.parse(jobRaw);
      try {
        const interviewData = JSON.parse(job?.jobAssessment);
        setInterviewQuestions(interviewData.interviewQuestions);
      } catch (error) {
        console.error("Error parsing interview data:", error);
      }
    }
  }, [jobRaw]);

  const handleSubmit = (values) => {
  };

  useEffect(() => {
    setInitialValues(generateInitialValues(interviewQuestions));
    setSchema(generateSchema(interviewQuestions));
  }, [interviewQuestions]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <div
        style={{
          backgroundColor: "#FFFFFF",
        }}
      >
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "8vh",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 25px 20px -20px rgba(0,0,0,0.1)",
            zIndex: "1000",
            paddingLeft: "10px",
            paddingRight: "15px",
          }}
        >
          <div className="d-flex gap-3 align-items-center">
            <img
              src={AvensysLogo2Img}
              alt=""
              style={{
                height: "6vh",
              }}
            />
            <div
              style={{
                borderLeft: "1px solid #E5E5E5",
                height: "6vh",
              }}
            ></div>
            <span className="fs-4 fw-bold">Self-Assessment</span>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Button
              className="btn btn-secondary"
              type="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-success"
              type="button"
              onClick={formik.handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
        <div className="">
          <div
            style={{
              width: "100%",
            }}
          >
            <JobInfoBanner />
            <div className="p-4 mt-4 d-flex flex-column align-items-center">
              <form
                onSubmit={formik.handleSubmit}
                style={{
                  width: "95%",
                }}
              >
                {/* // Map through the questions and render the form fields. 1) Questions, 2) Answer, 3) Experiences 4) Rating in stars */}
                <Row lg="4" className="mb-4">
                  {questionHeaders.map((header, index) => (
                    <Col>
                      <div className="d-flex align-items-center">
                        <span className="fw-semibold fs-5">{header}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
                {interviewQuestions.map((question, index) => (
                  <Row lg="4" className="mb-5" key={index}>
                    <Col>
                      <div className="d-flex align-items-center">
                        <span className="ms-2 fs-6">
                          {index + 1}. {question?.question}
                        </span>
                      </div>
                    </Col>

                    {/* Answer Field */}
                    <Col>
                      <div className="d-flex align-items-center">
                        <Input
                          type="textarea"
                          name={`[${index}].answer`}
                          className="form-control"
                          value={formik.values?.[index]?.answer || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                      {formik.touched?.[index]?.answer &&
                        formik.errors?.[index]?.answer && (
                          <div style={{ color: "red" }}>
                            {formik.errors[index].answer}
                          </div>
                        )}
                    </Col>

                    {/* Experience Field */}
                    <Col>
                      <div className="d-flex align-items-center">
                        <Input
                          type="textarea"
                          name={`[${index}].experience`}
                          className="form-control"
                          value={formik.values?.[index]?.experience || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                      {formik.touched?.[index]?.experience &&
                        formik.errors?.[index]?.experience && (
                          <div style={{ color: "red" }}>
                            {formik.errors[index].experience}
                          </div>
                        )}
                    </Col>

                    {/* Rating Field Use Rate */}
                    <Col>
                      <div className="fs-5 align-items-start">
                        Scale 1 to 5:
                      </div>
                      <div className="custom-rate">
                        <Rate
                          value={formik.values?.[index]?.rating || 0}
                          onChange={(value) => {
                            formik.setFieldValue(`[${index}].rating`, value);
                          }}
                          allowHalf={true}
                          allowClear={true}
                          style={{
                            fontSize: "2.5em",
                            lineHeight: "0.2em",
                          }}
                        />
                      </div>
                      {formik.touched?.[index]?.rating &&
                        formik.errors?.[index]?.rating && (
                          <div style={{ color: "red" }}>
                            {formik.errors[index].rating}
                          </div>
                        )}
                    </Col>
                  </Row>
                ))}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingSystem;
